import { createSlice } from '@reduxjs/toolkit'

import { loadCustomFields } from './customFields.actions'

interface InitialCustomFieldsState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: Object
}

const initialState: InitialCustomFieldsState = {
  status: 'idle',
  error: null,
  data: {},
}

export const customFieldsReducer = createSlice({
  name: 'customFields',
  initialState,
  reducers: {},
  extraReducers: {
    [loadCustomFields.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadCustomFields.fulfilled.toString()]: (state, action) => {
      const { payload } = action

      state.status = 'loaded'
      state.data[payload.cacheKey] = payload.data
    },
    [loadCustomFields.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer
